import React from "react";

import { Button } from "@mui/material";

import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";

export function RegisterButtons(props) {
  const {
    user,
    appName,
    applicationType,
    createApp,
    registerButtonDisabled,
    setCrudState,
  } = props;

  return (
    <GridContainer style={{ paddingBottom: "20px" }}>
      <GridItem xs={12}>
        <Button
          onClick={() => createApp(user, appName, applicationType)}
          disabled={registerButtonDisabled}
          color="primary"
          variant="contained"
        >
          Register
        </Button>
        <Button
          style={{ marginLeft: "1.0em" }}
          onClick={() => setCrudState("read")}
        >
          Cancel
        </Button>
      </GridItem>
    </GridContainer>
  );
}
